// Copyright (C) 2017-2022 Smart code 203358507

const MetaRowPlaceholder = require('./MetaRowPlaceholder');

module.exports = MetaRowPlaceholder;
